export enum AuthScopes {
  UsersManage = 'users.manage',
  OrdersManage = 'orders.manage',
  OrdersRead = 'orders.read',
  ReviewsManage = 'reviews.manage',
  ReviewsRead = 'reviews.read'
}
